import React from 'react'
import Currency from '../../../components/Currency'

const InvoiceSummaryLineItem = ({ item }) => {
  const { amount, description, citation } = item

  return (
    <>
      {!item.citation
        ? (
        <div className="flex justify-between">
          <div>{description}</div>
          <div>
            <Currency amount={amount} />
          </div>
        </div>
          )
        : (
        <>
          <div key={citation?.citationId} className="flex justify-between">
            <div>{citation?.violation}</div>
            <div>
              <Currency amount={citation?.balanceDue} />
            </div>
          </div>
        </>
          )}
    </>
  )
}

export default InvoiceSummaryLineItem
